import React from 'react';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    content: "LSEM's comprehensive program transformed my understanding of international trade. I now run a successful export business thanks to their practical approach.",
    author: "Sarah Johnson",
    position: "CEO, Global Trade Solutions",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80"
  },
  {
    content: "The mentorship and guidance I received at LSEM were invaluable. Their expert instructors provided real-world insights that textbooks simply can't offer.",
    author: "Michael Adebayo",
    position: "Export Operations Manager",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80"
  },
  {
    content: "As an entrepreneur, LSEM's executive program gave me the confidence and knowledge to expand my business internationally. Best investment in my career.",
    author: "Chioma Okonkwo",
    position: "Founder, African Exports Ltd",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80"
  }
];

const Testimonials = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-blue-50 border border-blue-200 text-blue-700 text-sm font-medium mb-5">
            Alumni Stories
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Real exporters. Real results.
          </h2>
        </div>

        <div className="grid gap-6 lg:grid-cols-3">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="relative rounded-2xl bg-white border border-gray-200 p-8 hover:shadow-lg transition-shadow"
            >
              <Quote className="absolute top-6 right-6 h-8 w-8 text-blue-100" />
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-yellow-400 fill-current" />
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-6">"{t.content}"</p>
              <div className="flex items-center pt-5 border-t border-gray-100">
                <img
                  className="h-11 w-11 rounded-full object-cover ring-2 ring-blue-100"
                  src={t.image}
                  alt={t.author}
                />
                <div className="ml-3">
                  <h4 className="font-semibold text-gray-900 text-sm">{t.author}</h4>
                  <p className="text-xs text-gray-500">{t.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;